import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import actionsReducer from './actionsReducer';
import authReducer from './authReducer';
import brokeringReducer from './brokeringReducer';
import contentReducer from './contentReducer';
import profileReducer from './profileReducer';
import userReducer from './userReducer';
import assessmentReducer from './assessmentReducer';
import offersReducer from './offersReducer';
import casesReducer from './casesReducer';
import pendingCasesReducer from './pendingCasesReducer';
import assignedCasesReducer from './assignedCasesReducer';
import lawyersReducer from './lawyersReducer';
import clientsReducer from './clientsReducer';
import threadsReducer from './threadsReducer';
import clientThreadsReducer from './clientThreadsReducer';
import messagesReducer from './messagesReducer';
import calendarReducer from './calendarReducer';
import navigationReducer from './navigationReducer';
import notificationsReducer from './notificationsReducer';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    actions: actionsReducer,
    auth: authReducer,
    brokering: brokeringReducer,
    content: contentReducer,
    profile: profileReducer,
    assessment: assessmentReducer,
    offers: offersReducer,
    cases: casesReducer,
    pendingCases: pendingCasesReducer,
    assignedCases: assignedCasesReducer,
    lawyers: lawyersReducer,
    clients: clientsReducer,
    threads: threadsReducer,
    clientThreads: clientThreadsReducer,
    messages: messagesReducer,
    events: calendarReducer,
    user: userReducer,
    navigation: navigationReducer,
    notifications: notificationsReducer
  });
